<div *ngIf="(panelDisplayStatus | async)" class="notification-panel-container d-flex flex-column">
  <div>
    <button class="close-btn" (click)='this.closePanel($event)'>
      <fa-icon [icon]='faTimes'></fa-icon>
    </button>
    <h2>Notifications</h2>

    <p class="link-container pt-3 pb-2 mb-0" *ngIf="notifications.length > 0">
      <a href="javascript:void(0);" class="float-right" (click)="dismissAll()">Dismiss all</a>
    </p>
    <div class="d-flex justify-content-center" *ngIf="notifications.length === 0">
      <div class="alert font-weight-bold">
        No new Notifications.
      </div>
    </div>
  </div>

  <div class="notification-container flex-grow-1">
    <div class="notification d-flex flex-column" *ngFor='let notification of notifications'>
      <div class="d-flex mb-2 align-items-start">
        <div class="backgroundjobgroup-status text-success" *ngIf='notification.status === "completed"'>
          <fa-icon [icon]='faCheckCircle' size="lg"></fa-icon>
        </div>
        <div class="backgroundjobgroup-status" [class.text-info]='notification.status === "processing"'
          [class.text-warning]='notification.status === "processing_failure"'
          *ngIf='notification.status === "processing" || notification.status === "processing_pending" || notification.status === "processing_failure"'>
          <fa-icon [icon]='faSpinner'></fa-icon>
        </div>
        <div class="backgroundjobgroup-status text-danger" *ngIf='notification.status === "failed"'>
          <fa-icon [icon]='faTimes'></fa-icon>
        </div>
        <div class="backgroundjobgroup-title" *ngIf='notification.status === "completed" || notification.status === "failed"'>{{notification.title}}</div>
        <div class="backgroundjobgroup-title saving" *ngIf='notification.status === "processing" || notification.status === "processing_failure" || notification.status === "processing_pending"'>
          {{notification.title}}
      </div>
    </div>
      <div class="backgroundjob-title" *ngIf='notification.status === "processing" || notification.status === "processing_failure" || notification.status === "processing_pending"'>
        {{notification.jobTitle}}<span>.</span><span>.</span><span>.</span>
      </div>
      <div class="backgroundjob-title" *ngIf='notification.status === "failed" || notification.status === "completed"'>
        {{notification.jobTitle}}</div>
      <div class="backgroundjobgroup-creation-time text-right">{{(notification.updateTime) | timeago}}</div>
    </div>
  </div>
</div>
